'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import React, { createContext, useContext } from 'react';

import { type HTTPClient } from '../types';

const HTTPContext = createContext<HTTPClient | null>(null);

interface HTTPProviderProps {
	client: HTTPClient;
	children: React.ReactNode;
	state?: unknown;
}

export const useHTTPContext = () => {
	const context = useContext(HTTPContext);
	if (!context) {
		throw new Error('useHTTPContext must be used within HTTPProvider');
	}
	return context;
};

export const HTTPProvider: React.FC<HTTPProviderProps> = ({ client, children }) => (
	<HTTPContext.Provider value={client}>
		<QueryClientProvider client={client.queryClient}>{children}</QueryClientProvider>
	</HTTPContext.Provider>
);
